import { Configuration, PublicClientApplication } from "@azure/msal-browser";

const msalConfig: Configuration = {
    auth: {
      clientId: process.env.REACT_APP_CLIENT_ID_2 as string,
      authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}` as string,
      redirectUri: process.env.REACT_APP_REDIRECT_URI as string
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: true
    }
  };
  
  const msalInstance = new PublicClientApplication(msalConfig);

  export default msalInstance
  